<script setup lang="ts">
import { defineEmits } from 'vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'

defineProps({
  loading: Boolean,
  disabled: {
    type: Boolean,
    default: false,
  },
})
defineEmits(['save'])
</script>

<template>
  <div class="modal-action">
    <slot />
    <ButtonDaisy text="Enregistrer" :disabled="disabled" @click="$emit('save')" :loader="loading" />
  </div>
</template>
